import React, { useEffect } from 'react'
import {
  Frame,
  List,
  ListItem,
  ListItemText,
  KeyboardArrowRightIcon,
  Heading,
} from 'components'

import {
  useHistory,
  makeStyles,
  getUserPortalLink,
  useSubscription,
} from 'utils'
import { useState } from 'react'

const SubscriberSettings = ({ user }) => {
  const { subscription } = useSubscription(user?.id)
  const [subscriptionUrl, setSubscriptionUrl] = useState()

  useEffect(() => {
    getUserPortalLink().then((url) => {
      setSubscriptionUrl(url)
    })
  }, [])

  return (
    <Frame maxWidth="xs" user={user}>
      <Heading>Settings & Account</Heading>

      <List>
        {/* Account Info */}
        <Item
          label="Update My Name"
          secondary={user && `${user.firstName} ${user.lastName}`}
          route="/settings/name"
        />
        <Item label="Change My Password" route="/settings/password" />

        {/* Freelancer Profile Settings */}
        <Item
          label="My City"
          secondary={(user && user.cities) ? user.cities.join(', ') : user.city}
          route="/settings/city"
        />
        <Item label="Email Preferences" route="/settings/email" />
        <Item
          label={`${user?.hidden ? 'Unhide' : 'Hide'} My Profile`}
          route="/settings/visibility"
        />

        {/* Hiring/Employer Settings */}
        <Item label="Update My Details" route="/settings/details" />
        <Item
          label="Manage Subscription"
          disabled={!subscription || !subscriptionUrl}
          onClick={() => window.location.assign(subscriptionUrl)}
        />
        <Item label="Unhide Freelancers" route="/settings/hidden_freelancers" />

        {/* Account Actions */}
        <Item label="Log out" route="/logout" />
        <Item label="Delete My Account" route="/settings/delete" />
      </List>
    </Frame>
  )
}

export default SubscriberSettings

const useStyles = makeStyles((theme) => ({ primary: { fontSize: 21 } }))

const Item = ({ onClick, label, route, secondary, ...props }) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <ListItem
      button
      disabled={props.disabled}
      onClick={onClick || (() => history.push(route))}
      {...props}
    >
      <ListItemText classes={classes} primary={label} secondary={secondary} />
      <KeyboardArrowRightIcon color="primary" />
    </ListItem>
  )
}
